import { BREAKPOINTS } from "configs/constants";
import { CF_ASSET_PATH } from "utilities/constants";
import { CfFileSingleImage } from "types/cf-utils/types";
import { CfImageProps, LoadingType, PriorityType } from "../types";
import { ConvertGenericImageProps } from "types/types";
import {
  IGatsbyImageData,
  getImage,
  withArtDirection,
} from "gatsby-plugin-image";
import { getDeepVal } from "utilities/utils";
import Image from "..";
import React, { CSSProperties } from "react";

type SingleImageOptions = {
  customClass?: string;
  slug?: string;
  loadingType?: LoadingType;
  featchPriority?: PriorityType;
  objectFit?: CSSProperties["objectFit"];
};

type ConvertSingleImage = {
  image: CfFileSingleImage | null;
  options?: SingleImageOptions;
};

export const convertSingleImage = ({
  image,
  options,
}: ConvertSingleImage): CfImageProps | undefined => {
  if (image) {
    return {
      __typename: image.__typename,
      id: image.id,
      contentful_id: image.contentful_id,

      alt: image.description,
      imageDesktop: image,
      customClass: (options && options.customClass) || "",
      slug: (options && options.slug) || "",
      ...(options &&
        options.loadingType && { loadingType: options.loadingType }),
      ...(options &&
        options.featchPriority && { featchPriority: options.featchPriority }),
      ...(options && options.objectFit && { objectFit: options.objectFit }),
    };
  }
  return undefined;
};

export const convertCfImageProps = ({
  alt,
  customClass,
  slug,
  imageDesktop,
  imageMobile,
  loadingType = "lazy",
  featchPriority = "auto",
  objectFit = "cover",
  breakpoint = BREAKPOINTS.sm,
}: ConvertGenericImageProps) => {
  let images: IGatsbyImageData | undefined;
  if (imageDesktop.gatsbyImageData) {
    if (imageMobile?.gatsbyImageData) {
      images = withArtDirection(getImage(imageDesktop.gatsbyImageData)!, [
        {
          media: `(max-width:${breakpoint}px)`,
          image: getImage(imageMobile?.gatsbyImageData)!,
        },
      ]);
    } else {
      images = getImage(imageDesktop.gatsbyImageData);
    }
  }

  return {
    slug: slug || undefined,
    alt: alt || "",
    customClass: customClass || undefined,
    gatsbyImage: images,
    imageDesktop: getDeepVal(imageDesktop, CF_ASSET_PATH) as string,
    imageMobile: getDeepVal(imageMobile, CF_ASSET_PATH) as string,
    loadingType,
    featchPriority,
    objectFit,
    // NOTE: objectFit - objectPosition
  };
};

const CfImage = (props: CfImageProps) => {
  return <Image {...convertCfImageProps(props)} />;
};

export default CfImage;
